import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography/Typography'
import S3Avatar from 'Components/S3Image/S3Avatar'
import PersonIcon from '@mui/icons-material/Person'
import PhoneIcon from '@mui/icons-material/Phone'
import EmailIcon from '@mui/icons-material/Email'
import { AsYouType } from 'libphonenumber-js'

interface Props {
  user: UserDetailsModel | null
  cardCaption?: string
}

export interface UserDetailsModel {
  firstName?: string
  lastName?: string
  isdName?: string
  securityLevel?: string
  phone?: string
  email?: string
  s3Key?: string
}

export const UserDetailsDisplay = (props: Props): JSX.Element => {
  const { user, cardCaption } = props

  if (user == null) { return <Skeleton /> }
  return <Box className='CardDisplay'>
    <Typography variant='h6' sx={{ fontWeight: 'bold' }} gutterBottom>{cardCaption ?? 'User Details'}</Typography>
    <Stack direction='column' spacing={1}>
      <Stack direction='row' spacing={1}>
        {user?.s3Key !== null && user?.s3Key != null ? <S3Avatar imageKey={user?.s3Key} height='30px' width='30px' /> : <PersonIcon />}
        <Stack direction='column'>
          <Typography variant='body1' sx={{ fontWeight: 'bold', overflowWrap: 'break-word' }}>
            {`${user?.firstName ?? ''} ${user?.lastName ?? ''}`}
          </Typography>
          {user?.isdName != null && <Typography variant='body1' sx={{ overflowWrap: 'break-word' }}>
            {user?.isdName}
          </Typography>}
          {user?.securityLevel != null && <Typography variant='body1' sx={{ overflowWrap: 'break-word' }}>
            {user?.securityLevel}
          </Typography>}
        </Stack>
      </Stack>
      {(user?.phone ?? '') !== '' && <Stack direction='row' spacing={1}>
        <PhoneIcon />
        <Typography variant='body1' sx={{ overflowWrap: 'break-word' }}>
          {new AsYouType('US').input(user.phone ?? '')}
        </Typography>
      </Stack>}
      {(user?.email ?? '') !== '' && <Stack direction='row' spacing={1}>
        <EmailIcon />
        <Typography variant='body1' sx={{ overflowWrap: 'anywhere' }}>
          {<a href={`mailto:${user?.email ?? ''}`}>
            {user?.email}
          </a>}
        </Typography>
      </Stack>}
    </Stack>
  </Box>
}
